import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class AuthorizedOnlyRouteGuard implements CanActivate {

    public canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        return !ETR.isAnonymous;
    }
}
